import styled, { css } from 'styled-components';

type BackgroundProps = {
  active?: boolean;
};

export const Background = styled.img<BackgroundProps>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, ${({ active = false }): number => (active ? 0.5 : 0)});
  transition: background-color ${({ active = false }): string => (active ? '200ms' : '0ms')};
  transition-delay: ${({ active = false }): string => (active ? '64ms' : '0ms')};
  width: 100%;
  height: 100%;
  z-index: ${({ active }): number => (active ? 2 : -9999)};
  display: ${({ active }): string => (active ? 'block' : 'none')};
  cursor: pointer;
`;

type ImageProps = {
  opened?: boolean;
};

export const Image = styled.img<ImageProps>`
  cursor: ${({ opened }): string => (opened ? 'inherit' : 'zoom-in')};
  z-index: ${({ opened }): number => (opened ? 99 : 1)};
  max-width: 100%;
  height: auto;
  object-fit: contain;
  ${({ opened }) =>
    opened &&
    css`
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 90%;
      max-height: 90%;
    `};
`;
